import React , {useState} from 'react'

import { useNavigate , useLocation } from "react-router-dom";

import "./styles.css"

export default function Header( { showMyExcel , showProducto , showHome , 
  showCatalogo , loadCodigo , showCatConfig , theShowDoCase , clear }) {


    const [visible,setVisible] = useState( true )   

    const navigate = useNavigate(); 




    function onCfdi()
    {
      console.log( "onCfdi")
      clear() ;
      navigate("/cfdiloader")
    }

    function onTipoCuenta()
    {
      console.log( "onTipoCuenta")
      clear() ;
      //navigate( "/configurador" )
      navigate( "/tipocuenta" )
    }

    function theConfigurador()
    {
      clear() ;
      navigate( "/configurador" )
    }

    function onFacturacion()
    {
      clear() ;

      setVisible( false)
      
      navigate( "/facturacion" )
    }

    function onPedidos()
    {
      clear() ;

      setVisible( false)

      navigate( "/pedidos" )
    }


    function onDivisas()
    {
      clear() ;

      console.log( "onDivisas")

      navigate( "/divisas" )
    }


    function onPromos()
    {
      clear() ;

      console.log( "onPromos")

      navigate( "/promos" ) // Aun no tememos la ruta de promos
    }

    function onTranslate()
    {
      clear() ;

      console.log( "onTranslate")

      navigate( "/translate" ) // 
    }

    function onLogin()
    {
      clear() ;

      console.log( "onLogin2")

      navigate( "/login2"  ) //
    }
    

  return (
    <div className='w-100'>

        <h1>Livefactura</h1>


        {
          visible  && (

            <div className='nav mb-5' style={{width:'100%' }}>
            <ul>
                 
                <li><a onClick={showHome} href="#home" class="active" >Home</a></li>
                <li><a onClick={showMyExcel} href="#Excel">Carga Excel</a></li>
                <li><a onClick={showProducto}  href="#producto">Prod Serv</a></li>
                <li><a onClick={showCatalogo} href="#catalogos">Cat Cuenta</a></li>
                <li><a onClick={loadCodigo} href="#catalogos">Código Agrupador</a></li>
                <li><a onClick={showCatConfig} href="#catconfig">Cat Config</a></li>
                <li><a onClick={theShowDoCase} href="#catconfig">Do Case</a></li> 
                <li><a onClick={theConfigurador} href="#">Configurador</a></li> 
                <li><a onClick={onTipoCuenta} href="#">TipoCuenta</a></li> 
                <li><a onClick={onCfdi} href="#">Cfdi</a></li> 
                <li><a onClick={onFacturacion} href="#facturacion">Facturacion</a></li>
                <li><a onClick={onPedidos} href="#">Pedidos</a></li>
                <li><a onClick={onDivisas} href="#" >Divisas</a></li>
                <li><a onClick={onPromos} href="#">Promociones</a></li>
                <li><a onClick={onTranslate} href="#">Traducciones</a></li>

                <li><a onClick={onLogin} href="#">Logout</a></li>
                
                <li><a href="#about">About</a></li>
            </ul>
        </div>
 

          )
      }

   </div>
  )
}
